module.exports = __webpack_public_path__ + "894a2ede85a483bf9bedefd4db45cdb9.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/Roboto-Medium.ttf
 ** module id = 380
 ** module chunks = 0
 **/